import script from "./Play.vue?vue&type=script&setup=true&lang=js"
export * from "./Play.vue?vue&type=script&setup=true&lang=js"

import "./Play.vue?vue&type=style&index=0&id=7590e947&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7590e947"]])

export default __exports__